// components/ReviewTemplateList/Common/CommonReviewList.tsx
import { Col, Row } from 'reactstrap';
import { Badges, H5, P, UL, LI, Image } from '../../../../AbstractElements';
import { dynamicImage } from '../../../../Utils';
import { Edit, Eye } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setReviewDetails } from '../../../../ReduxToolkit/ReviewReducers/ReviewReducer';
import Authorized from '../../../../CommonElements/Authorisation/Authorise';

interface ItemProps {
  item: any;
  refetchTemplates?: () => void;
}

export default function CommonReviewList({ item, refetchTemplates }: ItemProps) {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const redirectEdit = () => {
    // alert(JSON.stringify(item));
    dispatch(setReviewDetails(item));
    navigate(`${process.env.PUBLIC_URL}/book_review/edit`);
  }

  const badge = (item.assignments && item.assignments.length > 0) ? 'Assigned' : 'Unassigned';

  // first assignment snapshot (if any)
  const firstAssignment = item.assignments && item.assignments.length > 0 ? item.assignments[0] : null;

  return (
    <Col xxl={4} md={6}>
      <div className={`project-box font-dark`} style={{color:"#FF3500",borderColor:"#FF3500"}}>
        <Badges color="#FF3500">{badge}</Badges>

        <H5 className={`f-w-500 mb-2 mt-2`} style={{color:"#FF3500"}}>
          {firstAssignment?.group?.title} - {item.title}
        </H5>

        <div className="text-end">
          <button className="btn btn-sm me-2" style={{color:"#FF3500"}} title="View" onClick={() => navigate(`${process.env.PUBLIC_URL}/book_review/view/${item._id || item.id}`)}>
                      <Authorized allowed={["participant"]}>
                        <Edit/>
                        </Authorized>

            <Authorized allowed={["admin", "group leader"]}>
              <Eye />
            </Authorized>
          </button>

          <Authorized allowed={["admin", "group leader"]}>
            <button className="btn btn-sm btn-primary me-2" onClick={redirectEdit} title="Edit">
              <Edit />
            </button>
          </Authorized>

          {/* <button className={`btn btn-sm btn-${badge === 'Assigned' ? 'danger' : 'success'}`} title={badge === 'Assigned' ? 'Archive' : 'Mark'}>
            {badge === 'Assigned' ? <Archive /> : <CheckCircle />}
          </button> */}
        </div>

        <div className="d-flex mb-2 align-items-center">
          {/* <Image
            className="img-20 me-1 rounded-circle"
            src={dynamicImage(`user/${item.createdBy?.avatar || '1.jpg'}`)}
            alt=""
          /> */}
          <P className="font-light mt-1"> <strong>Tags: </strong> {(item.tags || []).join(', ')}</P>
        </div>

        <P>{item.description || 'No description'}</P>

        <Row className="details">
          <Col className='mt-2' xs={6}><span>{'Review Created By'}</span></Col>
          <Col xs={6} style={{color:"#FF3500"}}>
            {item.createdBy?.firstname || ''} {item.createdBy?.lastname || ''}
          </Col>

          <Col xs={6}><span>{'Assignments'}</span></Col>
          <Col xs={6} style={{color:"#FF3500"}}>
            {item.assignments ? item.assignments.length : 0}
          </Col>

          <Col xs={6}><span>{'Questions'}</span></Col>
          <Col xs={6} style={{color:"#FF3500"}}>
            {((item.sections?.pre?.length || 0) + (item.sections?.during?.length || 0) + (item.sections?.post?.length || 0))}
          </Col>

          {firstAssignment && (
            <>
              <Col xs={6}><span>{'Available From'}</span></Col>
              <Col xs={6} style={{color:"#FF3500"}}>
                {firstAssignment.visibleFrom ? new Date(firstAssignment.visibleFrom).toLocaleDateString() : '—'}
              </Col>
              <Col xs={6}><span>{'Available Until'}</span></Col>
              <Col xs={6} style={{color:"#FF3500"}}>
                {firstAssignment.visibleTo ? new Date(firstAssignment.visibleTo).toLocaleDateString() : '—'}
              </Col>
            </>
          )}
        </Row>

        {/* <div className="customers mt-2">
          <UL className="simple-list flex-row">
            {(item.tags || []).slice(0, 4).map((t: string, i: number) => (
              <LI className="d-inline-block" key={i} style={{ marginRight: 8 }}>
                <P className="f-12">{t}</P>
              </LI>
            ))}
            {(item.tags || []).length > 4 && (
              <LI className="d-inline-block ms-2">
                <P className="f-12">{`+${(item.tags || []).length - 4} more`}</P>
              </LI>
            )}
          </UL>
        </div> */}

        {/* <Modal centered isOpen={editModal} toggle={toggleEditModal}>
          <CreateNewGroupForm />
        </Modal> */}
      </div>
    </Col>
  );
}
